import Box from 'components/shared/Box'
import TicketRow from './TicketRow'
import { useAppSelector } from 'store/hooks'
import TicketItem from './TicketItem'
import RouteTitle from 'components/shared/RouteTitle'
import { useIntl } from 'react-intl'
import { getDayNameAndDateWithTime, getDayNameAndDate } from 'helpers/dates'
import { directionNames } from 'helpers/translations'
import { BusTicketWithDetails } from 'store/api-slice/types'

const NewBusTickets = () => {
    const { transport } = useAppSelector((state) => state.selfcare)
    const { items } = useAppSelector((state) => state.selfcareCart)
    const { busTickets: newBusTickets } = items
    const { formatMessage } = useIntl()

    const separatedNewBusTickets = () => {
        const separatedTickets: BusTicketWithDetails[] = []

        // ignore already existed, but edited bus tickets from cart - consider only newly added
        const changedBoxes =
            transport?.map(
                (orderTicket) => orderTicket.changes?.detail.boxId
            ) || []
        const onlyNewBusTickets = newBusTickets.filter(
            (cartTicket) => !changedBoxes.includes(cartTicket.detail.boxId)
        )

        // separate multiple tickets (quantity > 1) into single ones
        onlyNewBusTickets.forEach((newTicket) => {
            Array.from(Array(newTicket.quantity || 0).keys()).forEach(() =>
                separatedTickets.push(newTicket)
            )
        })

        return separatedTickets
    }

    return (
        <>
            {newBusTickets.length > 0 &&
                separatedNewBusTickets().map((ticket, index) => {
                    const { totalPrice, cartItemId, detail, unitPrice } = ticket
                    const {
                        time,
                        date,
                        routeType,
                        returnTime,
                        returnDate,
                        departurePlace,
                    } = detail

                    const from =
                        routeType === 'from_park'
                            ? directionNames.suntago
                            : directionNames[departurePlace]
                    const to =
                        routeType === 'from_park'
                            ? directionNames[departurePlace]
                            : directionNames.suntago

                    return (
                        totalPrice && (
                            <Box
                                gap={[16, 24]}
                                isFullWidth
                                key={`${cartItemId}-${index}`}
                            >
                                <TicketRow
                                    price={unitPrice || 0}
                                    key={`${cartItemId}${index}`}
                                >
                                    <Box gap={[16, 24]} isFullWidth>
                                        <TicketItem
                                            date={
                                                time
                                                    ? getDayNameAndDateWithTime(
                                                          { date, time }
                                                      )
                                                    : getDayNameAndDate({
                                                          date,
                                                      })
                                            }
                                            editedItem="newItem"
                                        >
                                            <RouteTitle
                                                from={formatMessage(from)}
                                                to={formatMessage(to)}
                                                variant="bodySmall"
                                                hasSmallDots
                                                color="primary_500"
                                            />
                                        </TicketItem>
                                        {routeType === 'to_from_park' && (
                                            <TicketItem
                                                date={
                                                    returnTime
                                                        ? getDayNameAndDateWithTime(
                                                              {
                                                                  date: returnDate,
                                                                  time: returnTime,
                                                              }
                                                          )
                                                        : getDayNameAndDate({
                                                              date: returnDate,
                                                          })
                                                }
                                                editedItem="newItem"
                                            >
                                                <RouteTitle
                                                    from={formatMessage(to)}
                                                    to={formatMessage(from)}
                                                    variant="bodySmall"
                                                    hasSmallDots
                                                    color="primary_500"
                                                />
                                            </TicketItem>
                                        )}
                                    </Box>
                                </TicketRow>
                            </Box>
                        )
                    )
                })}
        </>
    )
}

export default NewBusTickets
